import { Tab } from '@mui/material';
import React, { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';

import { PageHeader, QueryTabPanel, QueryTabs } from 'components';
import { TranslationNamespace } from 'i18n';

import { RequisitesDistributionCachePage } from './RequisitesDistributionCachePage';
import { RequisitesDistributionDebugPage } from './RequisitesDistributionDebugPage';

enum RequisitesDebugTabs {
  DistributionCache = 'distribution_cache',
  RequisitesDebug = 'requisites_debug',
}

export const RequisitesDebugPage: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.requisites',
  });
  const outletContext = useOutletContext<{
    headerSubcontent?: ReactElement;
  }>();

  return (
    <Fragment>
      <PageHeader
        title={t('title')}
        divider={false}
        subcontent={outletContext?.headerSubcontent}
      />
      <QueryTabs tabsEnum={RequisitesDebugTabs}>
        <Tab
          value={RequisitesDebugTabs.DistributionCache}
          label={t('tabs.distribution_cache')}
        />
        <Tab
          value={RequisitesDebugTabs.RequisitesDebug}
          label={t('tabs.requisites_debug')}
        />
      </QueryTabs>
      <QueryTabPanel value={RequisitesDebugTabs.DistributionCache}>
        <RequisitesDistributionCachePage embedded />
      </QueryTabPanel>
      <QueryTabPanel value={RequisitesDebugTabs.RequisitesDebug}>
        <RequisitesDistributionDebugPage embedded />
      </QueryTabPanel>
    </Fragment>
  );
};
